import { Box, Typography, Stack } from "@mui/material"
import Sketch from "components/Sketch"
import Link from "components/Link"

interface Props {
  metadata: any
}

const Frame = ({ metadata }: Props) => {
  return (
    <Box fontFamily={"Inter"} fontSize={14} fontWeight={200} color="#d1d0cf">
      <Stack direction="row" spacing={0} justifyContent="space-between">
        <Box paddingLeft={1}>
          <Typography fontFamily={"inherit"} fontSize={"inherit"} fontWeight={"inherit"} color={"inherit"}>
            {metadata.id}
          </Typography>
        </Box>
        <Stack direction="row" justifyContent={"flex-end"}>
          <Box paddingRight={1}>
            <Link 
              label={metadata.block_hash.slice(0, 8)} 
              url={`https://etherscan.io/block/${metadata.block_number}`}
            />
            <Typography fontFamily={"inherit"} fontSize={"inherit"} fontWeight={"inherit"} color={"inherit"}>
              {metadata.creator_addr.slice(0, 4)}...{metadata.creator_addr.slice(-4)}
            </Typography>
          </Box>
        </Stack>
      </Stack>
      <Box padding={"2em 6em 6em 6em"}>
        <Box>
          <Sketch
            hash={metadata.block_hash} 
            params={metadata.settings}
          />
        </Box>
      </Box>
    </Box>
  )
}

export default Frame